import React from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "../../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../../utils/text-constants/textConstants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "436px",
    width: "850px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface ViewDialogForDataImportProps {
  isOpen: boolean;
  dialogHeading: string;
  handleClose: () => void;
  defaultDataForDataImport: any;
}

const ViewDialogForDataImport = ({
  isOpen = false,
  defaultDataForDataImport,
  handleClose,
  dialogHeading = "Your Heading Here...",
}: ViewDialogForDataImportProps) => {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          {defaultDataForDataImport ? (
            <div
              style={{
                padding: "24px 16PX",
                display: "grid",
                gap: "24px 16px",
                gridTemplateColumns: "1fr 1fr",
                border: "1px solid #E8E8E8",
              }}
            >
              <p>
                <strong>Import Initiated: </strong>
                {defaultDataForDataImport?.importInitiated}
              </p>
              <p>
                <strong>Entity: </strong>
                {defaultDataForDataImport?.entity}
              </p>

              <p>
                <strong>File name: </strong>{" "}
                {defaultDataForDataImport?.fileName || ""}
              </p>
              <p>
                <strong>Status: </strong>{" "}
                {defaultDataForDataImport?.status || ""}
              </p>
              <p>
                <strong>TotalRecord:</strong>{" "}
                {defaultDataForDataImport?.totalRecord || ""}
              </p>
              <p>
                <strong>Username:</strong>{" "}
                {defaultDataForDataImport?.username || "-"}
              </p>
            </div>
          ) : (
            <p>No task data available</p>
          )}
        </DialogContent>
        <DialogActions>
          <div className="p-2">
            <Button
              // disabled={!isValid} // Button disabled if form is invalid or submitting
              label={TEXT_CONSTANTS?.CLOSE}
              variant="contained"
              onClickCb={handleClose}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginRight: "6px",
              }}
            ></Button>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default ViewDialogForDataImport;
